import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { doUpdateClassTime } from '../../store/class.slice';
import { doRemoveAuth } from '../../store/auth.slice';
import moment from 'moment';

import { useSnackbar } from 'notistack';
import { Button as AntButton, DatePicker, Modal } from 'antd';
import { errorVariant, successVariant, warningVariant } from '../../lib/barVariant';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  classItem: any;
}

const SelectDateModal: FC<IProps> = ({ visible, setVisible, classItem }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const history = useHistory();

  const [startDate, setStartDate] = useState('');

  const onSubmit = async () => {
    const req = {
      classTimeCode: classItem.classTimeCode,
      srtTime: classItem.startTime,
      teacherCode: classItem.teacher.memberCode,
      classRoomCode: classItem.classroom,
      changeDate: startDate
    }

    const res = await dispatch(doUpdateClassTime(classItem.classTimeCode, req));

    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.save1'), successVariant);
        setVisible(false);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }

  }

  return (
    <Modal
      title={t('class.class.title6')}
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onSubmit}
            disabled={!startDate}
          >
            {t('common.button.save')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.cancel')}
          </AntButton>
        </div>
      ]}
    >
      <div className="flex flex-justify-center">
        <span className="px-4 v-line">
          {t('class.class.column27')}
        </span>
        <div className="date-picker__area">
          <DatePicker
            value={startDate ? moment(startDate) : undefined}
            onChange={e => {
              if (e === null) setStartDate('');
              else setStartDate(moment(e).format('YYYYMMDD'))
            }}
          />
        </div>
      </div>
      <div className="text-center mt-2">
        {`* ${t('class.class.text11')}`}
      </div>
    </Modal>
  );
}

export default SelectDateModal;
